import React, { Fragment, useEffect, useRef, useState } from "react";
import { NumberTool, StringTool } from "../../tool";
import style from "./datePicker.css"

interface DatePickerProps {
  clearable?: boolean
  disabled?: boolean
  value?: Date
  onChange?: (value: any) => void
  minDate?: Date
  maxDate?: Date
  renderView: (inputProps: React.HtmlHTMLAttributes<HTMLInputElement>, clearButtonProps: React.ButtonHTMLAttributes<HTMLButtonElement>) => any
};

const DatePicker = (props: DatePickerProps) => {

  const days = [
    {
      day: 0,
      name: "CN"
    },
    {
      day: 1,
      name: "T2"
    },
    {
      day: 2,
      name: "T3"
    },
    {
      day: 3,
      name: "T4"
    },
    {
      day: 4,
      name: "T5"
    },
    {
      day: 5,
      name: "T6"
    },
    {
      day: 6,
      name: "T7"
    }
  ]

  const { value, minDate, maxDate, onChange } = props

  const [valueState, setValueState] = useState(null as unknown | Date)
  const [showCalendar, setShowCalendar] = useState(false)
  const [showMonthPicker, setShowMonthPicker] = useState(false)
  const [showYearPicker, setShowYearPicker] = useState(false)
  const [month, setMonth] = useState(()=>{
    return new Date().getMonth()
  })
  const [year, setYear] = useState(()=>{
    return new Date().getFullYear()
  })
  const [date, setDate] = useState(()=>{
    return new Date().getDate()
  })
  const [dates, setDates] = useState([] as Array<any>)
  const [months, setMonths] = useState([] as Array<any>)
  const [years, setYears] = useState([] as Array<any>)

  const yearRef = useRef(null as any)

  useEffect(() => {
    setValueState(value)
  }, [value])

  useEffect(() => {
    let firstDate = new Date(year, month, 1);
    let firstDay = firstDate.getDay()
    let lastDate = new Date(year, month + 1, 0);
    let lastDateInMonth = lastDate.getDate()
    let lastDay = lastDate.getDay()
    let preArray = []
    let afterArray = []
    for (let i = 0; i < firstDay; i++) {
      preArray.push({
        disable: true,
        value: null,
        id: i - 40,
        isActive: false,
        isCurrent: false
      })
    }
    for (let j = 6; j > lastDay; j--) {
      afterArray.push({
        value: null,
        disable: true,
        id: j + 40,
        isActive: false,
        isCurrent: false
      })
    }
    let days = Array.from({ length: lastDateInMonth }, (_, i) => ({
      disable: false,
      value: i + 1,
      isActive: false,
      isCurrent: false
    }))
    let arr = [...preArray, ...days, ...afterArray]
    let minYear = minDate?.getFullYear() || 0
    let minMonth = minDate?.getMonth() || 0
    let minDate1 = minDate?.getDate() || 0

    let maxYear = maxDate?.getFullYear() || 0
    let maxMonth = maxDate?.getMonth() || 0
    let maxDate1 = maxDate?.getDate() || 0

    arr.forEach(d => {
      let disable = false
      if (!d.disable) {
        if (minDate) {
          if (year < minYear) {
            disable = true
          }
          if (year == minYear) {
            if (month < minMonth) {
              disable = true
            }
            if (month == minMonth) {
              if ((d.value || 0) < minDate1) {
                disable = true
              }
            }
          }
        }
        if (maxDate) {
          if (year > maxYear) {
            disable = true
          }
          if (year == maxYear) {
            if (month > maxMonth) {
              disable = true
            }
            if (month == maxMonth) {
              if ((d.value || 0) > maxDate1) {
                disable = true
              }
            }
          }
        }
        d.disable = disable
      }
    })
    let current = new Date()
    if (month == current.getMonth() && year == current.getFullYear()) {
      let suggest = arr?.find(t => t.value == current.getDate())
      if (suggest && !suggest.disable) {
        suggest.isCurrent = true
      }
    }
    if (valueState && month == (valueState as Date).getMonth() && year == (valueState as Date).getFullYear()) {
      let active = arr?.find(t => t.value == (valueState as Date).getDate())
      if (active && !active.disable) {
        active.isActive = true
      }
    }
    setDates(arr)
  }, [month, year, minDate, maxDate, valueState])

  useEffect(() => {
    let newArr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(t => ({
      disable: false,
      value: t
    }))
    let minYear = minDate?.getFullYear() || 0
    let minMonth = minDate?.getMonth() || 0

    let maxYear = maxDate?.getFullYear() || 0
    let maxMonth = maxDate?.getMonth() || 0
    newArr.forEach(m => {
      let disable = false
      if (minDate) {
        if (year < minYear) {
          disable = true
        }
        if (year == minYear) {
          if (m.value < minMonth) {
            disable = true
          }
        }
      }
      if (maxDate) {
        if (year > maxYear) {
          disable = true
        }
        if (year == maxYear) {
          if (m.value > maxMonth) {
            disable = true
          }
        }
      }
      m.disable = disable
    })
    setMonths(newArr)
  }, [year, minDate, maxDate])

  useEffect(() => {
    const currentDate = new Date()
    let maxYear = currentDate.getFullYear() + 100
    if (maxDate) {
      maxYear = maxDate.getFullYear()
    }
    let minYear = currentDate.getFullYear() - 100
    if (minDate) {
      minYear = minDate.getFullYear()
    }
    let newYears = Array.from({ length: maxYear - minYear + 1 }, (_, i) => (minYear + i))
    setYears(newYears?.reverse())
  }, [minDate, maxDate])

  useEffect(()=>{
    if(showYearPicker){
      yearRef.current?.scrollIntoView({
        block: "center"
      })
    }
  }, [showYearPicker])


  const onClick = () => {
    if (!props.disabled) {
      if (valueState) {
        setMonth((valueState as Date).getMonth())
        setYear((valueState as Date).getFullYear())
        setDate((valueState as Date).getDate())
      }
      else {
        let current = new Date()
        setMonth(current.getMonth())
        setYear(current.getFullYear())
        setDate(current.getDate())
      }
      setShowCalendar(true)
    }
  }

  const onClickBackdrop = () => {
    setShowCalendar(false)
  }
  const onClickClose = () => {
    setShowCalendar(false)
  }

  const onClickMonthLabel = () => {
    setShowMonthPicker(prev => !prev)
    setShowYearPicker(false)
  }
  const onClickYearLabel = () => {
    setShowYearPicker(prev => !prev)
    setShowMonthPicker(false)
  }
  const onClickMonth = (e: any) => {
    let newMonth = +e.target.innerText - 1
    setMonth(newMonth)
    setShowMonthPicker(false)
  }
  const onClickYear = (e: any) => {
    let newYear = +e.target.innerText
    setYear(newYear)
    setShowYearPicker(false)
  }
  const onClickDate = (e: any) => {
    let vlue = +e.target.innerText
    if (!valueState || (valueState as Date).getDate() != vlue || (valueState as Date).getMonth() != month || (valueState as Date).getFullYear() != year) {
      let newDate = new Date(year, month, vlue)
      setValueState(newDate)
      onChange && onChange(newDate)
    }
    setShowCalendar(false)
  }
  const onClickNextMonth = () => {
    setMonth(prev => {
      let newMonth = prev
      if (newMonth == 11) {
        newMonth = 0
        setYear(y => y + 1)
      }
      else {
        newMonth = newMonth + 1
      }
      return newMonth
    })
  }
  const onClickBackMonth = () => {
    setMonth(prev => {
      let newMonth = prev
      if (newMonth == 0) {
        newMonth = 11
        setYear(y => y - 1)
      }
      else {
        newMonth = newMonth - 1
      }
      return newMonth
    })
  }
  const onClickClear = () => {
    setValueState(null)
    setShowCalendar(false)
    onChange && onChange(null)
  }

  let text = ""
  let haveValue = false
  if (valueState) {
    text = NumberTool.convertToString((valueState as Date).getDate(), 2) + "/" + NumberTool.convertToString((valueState as Date).getMonth() + 1, 2) + "/" + (valueState as Date).getFullYear()
    haveValue = true
  }
  const inputProps = {
    readOnly: true,
    onClick: onClick,
    value: text
  } as React.InputHTMLAttributes<HTMLInputElement>
  const clearButtonProps = {
    onClick: onClickClear,
    hidden: valueState ? false : true
  } as React.ButtonHTMLAttributes<HTMLButtonElement>
  return (
    <Fragment>
      {
        props.renderView(inputProps, clearButtonProps)
      }
      {
        showCalendar &&
        <Fragment>
          <div onClick={onClickBackdrop} className={style.backdrop}>
          </div>
          <div className={style.calendar}>
            <div className={style.head}>
              <div className={style.month_group}>
                <button type="button" className={style.back_month} onClick={onClickBackMonth}>
                  <svg fill="rgba(0, 0, 0, 0.54)" width={24} height={24} focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ArrowLeftIcon">
                    <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"></path>
                  </svg>
                </button>
                <button type="button" onClick={onClickMonthLabel} className={style.month_label}>Tháng {month + 1}</button>
                <button type="button" className={style.next_month} onClick={onClickNextMonth}>
                  <svg fill="rgba(0, 0, 0, 0.54)" width={24} height={24} focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ArrowRightIcon">
                    <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path>
                  </svg>
                </button>
              </div>
              <button type="button" onClick={onClickYearLabel} className={style.year_label}>{year}</button>
            </div>
            <div className={style.body}>
              <div className={style.days}>
                {
                  days.map(d => {
                    return (
                      <label key={d.day} className={style.day}>{d.name}</label>
                    )
                  })
                }
              </div>
              <div className={style.dates}>
                {
                  dates.map((date, index) => {
                    return (
                      <button
                        type="button"
                        onClick={onClickDate}
                        key={date.value || date?.id}
                        disabled={date.disable}
                        className={StringTool.mergeClassName(style.date, date?.isActive ? style.active : "", date?.isCurrent ? style.current : "")}
                      >
                        {date.value}
                      </button>
                    )
                  })
                }
              </div>
              {
                showMonthPicker &&
                <div className={style.months}>
                  {
                    months.map(m => {
                      return (
                        <button type="button" disabled={m.disable} key={m.value} className={style.month} onClick={onClickMonth}>{m.value + 1}</button>
                      )
                    })
                  }
                </div>
              }
              {
                showYearPicker &&
                <div className={style.years}>
                  {
                    years?.map((yearValue, index) => {
                      let isActive = (yearValue == year)
                      return (
                        <button ref={isActive ? yearRef : null} type="button" key={yearValue} onClick={onClickYear} className={style.year}>{yearValue}</button>
                      )
                    })
                  }
                </div>
              }

            </div>
            <div className={style.actions}>
              {
                props.clearable && haveValue &&
                <button type="button" className={style.action} onClick={onClickClear}>Xóa</button>
              }
              <button type="button" className={StringTool.mergeClassName(style.action, style.close)} onClick={onClickClose}>Đóng</button>
            </div>
          </div>
        </Fragment>
      }
    </Fragment >
  )
}

export default DatePicker;
